import { isAndroid, isIOS } from './ua';

/**
 * 原生端的回调
 * @param {string} res 
 * @return {void}
 */
export function callbackFromNative(res) {
  let json;
  console.log('消息回调');
  console.log(res);
  const EventEmitter = window.EventEmitter;
  if (res && typeof res === 'string') {
    json = JSON.parse(res);
    if (json.type) {
      if (typeof EventEmitter == 'function' && EventEmitter.instance) {
        EventEmitter.instance.emit(json.type, [json.data]);
      }
    }
  }
}

/**
 * 关闭webview
 * @return {void}
 */
export function closeWeb() {
  if (isAndroid()) {
    androidInteraction({ type: 'closeWebView', data: {} });
  }

  if (isIOS()) {
    iosInteraction('closeWebView');
  }
}

/**
 * @param {Object} json
 * @example
 * var params = {
 *     type: 'orderProduct',
 *     data: {
 *         skuCode: '',
 *         channel: '',
 *         payChanel: '',
 *         orderType: ''
 *     }
 * }
 */
function androidInteraction(json) {
  // 数据类型
  if (json && typeof json != 'string') {
    json = JSON.stringify(json);
  }
  window.Android.sendMessageToNative(json);
}

/**
 * IOS交互
 * @param {string} type 交互名称
 * @param {string} data 数据
 */
export function iosInteraction(type, data) {
  if (window.webkit && window.webkit.messageHandlers) {
    window.webkit.messageHandlers[type].postMessage(data ? data : null);
  }
}

/**
 * 触发与native的交互
 * @param {string | Object} params 
 */
export function triggerInteraction(params) {
  if (isAndroid()) {
    androidInteraction(params);
  }

  if (isIOS()) {
    iosInteraction('sendMessageToNative', params);
  }
}
